import { SIGN_IN_START, LOGOUT_START } from '../../consts/actionTypes';

export const signIn = (payload) => ({
    type: SIGN_IN_START,
    payload,
});
export const logOutAction = () => ({
    type: LOGOUT_START,
});
